import http from "@/http-common";
import './security';


class MiscServices {

    /* Obtener grafica de tramas deco/no deco */
    getServerDate() {
        return http.get("/misc/date");
    }

    getAcronym() {
        return http.get("/misc/acronym");
    }

}
export default new MiscServices();